interface CropFieldWithId {
  id: number;
}

interface RegistrationWithCropFieldId {
  cropFieldId: number;
}

interface RowWithCreatedAt {
  createdAt: Date;
}

export interface CropFieldHistoryTable<TCropField, TRow> {
  cropField: TCropField;
  rows: TRow[];
}

export function buildCropFieldHistoryTables<
  TCropField extends CropFieldWithId,
  TRegistration extends RegistrationWithCropFieldId,
  TRow extends RowWithCreatedAt,
>(cropFields: TCropField[], registrations: TRegistration[], mapToRow: (registration: TRegistration) => TRow): CropFieldHistoryTable<TCropField, TRow>[] {
  return cropFields.map((cropField) => {
    const rows = registrations
      .filter((registration) => registration.cropFieldId === cropField.id)
      .map((registration) => mapToRow(registration))
      .sort((left, right) => right.createdAt.getTime() - left.createdAt.getTime());

    return {
      cropField,
      rows,
    };
  });
}
